import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../images/logo.jpeg';

const Header: React.FC = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [activeNav, setActiveNav] = useState<string>('/');

  // Update active nav indicator based on current route
  useEffect(() => {
    setActiveNav(location.pathname);
  }, [location.pathname]);

  // Mobile menu and hamburger functionality
  useEffect(() => {
    const hamburger = document.querySelector('.hamburger') as HTMLElement;
    const navLinks = document.querySelector('.nav-links') as HTMLElement;

    if (hamburger && navLinks) {
      const toggleMenu = () => {
        hamburger.classList.toggle('active');
        navLinks.classList.toggle('active');
      };

      hamburger.addEventListener('click', toggleMenu);

      navLinks.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          hamburger.classList.remove('active');
          navLinks.classList.remove('active');
        });
      });

      const handleClickOutside = (event: Event) => {
        if (!event.target || !(event.target as Element).closest('nav')) {
          hamburger.classList.remove('active');
          navLinks.classList.remove('active');
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => {
        hamburger.removeEventListener('click', toggleMenu);
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, []);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  // Helper function to determine if a nav link is active
  const isActiveLink = (path: string): boolean => {
    return activeNav === path || (path === '/' && activeNav === '/');
  };

  return (
    <header>
      <nav>
        <Link to="/" className="logo">
          <img src={logo} alt={t('logo_alt')} />
        </Link>
        <ul className="nav-links">
          <li>
            <Link 
              to="/" 
              className={isActiveLink('/') ? 'nav-link-active' : ''}
              title={t('home')}
            >
              {t('home')}
            </Link>
          </li>
          <li>
            <Link 
              to="/about" 
              className={isActiveLink('/about') ? 'nav-link-active' : ''}
              title={t('about')}
            >
              {t('about')}
            </Link>
          </li>
          <li>
            <Link 
              to="/products" 
              className={isActiveLink('/products') ? 'nav-link-active' : ''}
              title={t('products')}
            >
              {t('products')}
            </Link>
          </li>
          <li>
            <Link 
              to="/franchise" 
              className={isActiveLink('/franchise') ? 'nav-link-active' : ''}
              title={t('franchise')}
            >
              {t('franchise')}
            </Link>
          </li>
          <li>
            <Link 
              to="/contact" 
              className={isActiveLink('/contact') ? 'nav-link-active' : ''}
              title={t('contact')}
            >
              {t('contact')}
            </Link>
          </li>
        </ul>
        <select
          id="langSwitcher"
          value={i18n.language}
          onChange={(e) => changeLanguage(e.target.value)}
        >
          <option value="en">{t('language_en')}</option>
          <option value="hi">{t('language_hi')}</option>
          <option value="mr">{t('language_mr')}</option>
        </select>
        <button
          className="hamburger"
          aria-label="Toggle navigation menu"
          aria-expanded={false}
          type="button"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>
    </header>
  );
};

export default Header;